/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC, ReactElement } from 'react'
import zendesk from '../../assets/icons/zendesk.svg'
import { Container } from './styles'

type ContactCardProps = {
  title: string;
  subtitle: string;
  icon: string;
  href?: string;
  onClick?: () => any;
  isZendesk?: boolean;
}

const ContactCard: FC<ContactCardProps> = ({
  href,
  icon,
  title,
  subtitle,
  isZendesk,
  onClick
}): ReactElement => {
  return (
    <Container href={href} onClick={onClick}>
      <img src={icon} />
      <div className='content'>
        <b>{title}</b>
        {subtitle}
      </div>
      {isZendesk && <img className='zendesk' alt='zendesk' src={zendesk} />}
    </Container>
  )
}

export default ContactCard
